
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcBipolarTransistor as ObcBipolarTransistorElement} from '@oicl/openbridge-webcomponents/dist/automation/bipolar-transistor/bipolar-transistor.js';
 
 
 

 
 export const ObcBipolarTransistor = createComponent({
   react: React,
   tagName: 'obc-bipolar-transistor',
   elementClass: ObcBipolarTransistorElement,
   events: {
     
   }
  });
 
 